<template>
  <div class="sortable-panels-popup-container">
    <template v-if="panelsToMove.length > 1">
      <div class="sortable-panels-popup-content" id="sortable-panels-popup">
        <div class="ordenated-panel-content" v-for="(panel, index) in panelsToMove" :data-id="panel.id">
          <p class="text-truncate">
            <span v-if="panel.config.panelName">{{panel.config.panelName}}</span>
            <span v-else>{{ $t('ct-panel') }} {{ index + 1 }} </span>
            <span v-if="panel.config.anchorActive">#{{ panel.config.anchorName }}</span>
          </p>
          <div
            :key="`panel-move-${panel.id}`"
            class="ordenated-panel shadow-sm"
            :data-id="panel.id"
            :style="{'background': panel.background, 'border' : panel.borderShow} ">
          </div>
        </div>
      </div>

      <div class="sortable-button">
        <button class="btn btn-primary" @click="saveOrderPanels">{{ $t('ct-move') }}</button>
        <small class="text-center mt-2">{{ $t('ct-panel-move-popup-helper') }}</small>
      </div>
    </template>

    <p class="pt-4 m-0 text-center" v-else>{{ $t('ct-panel-order-empty') }}</p>
  </div>
</template>

<script>
import Sortable from "sortablejs";

export default {
  name: "PanelsToMove",
  data() {
    return {
      panelsToMove: [],
      sortable: false,
    }
  },
  methods: {
    makePanelsToOrder() {
      let vm = this;
      this.panelsToMove = [];

      function _newElement(element, index) {

        let obj = {
          id: element.getAttribute('id'),
          config: JSON.parse(element.getAttribute('config-properties')),
        }

        let bg = obj.config.backgroundColor;

        if (obj.config.backgroundImage !== 'none' && typeof obj.config.backgroundImage !== 'undefined') {

          bg += ' url("' + obj.config.backgroundImage + '")';
          bg += ' ' + obj.config.backgroundPosition;
          bg += ' / ' + obj.config.backgroundSize;
          bg += ' ' + obj.config.backgroundRepeat;
          bg += ' ' + obj.config.backgroundOrigin;
          if (typeof obj.config.backgroundAttachment !== 'undefined')
            bg += ' ' + obj.config.backgroundAttachment;
        }

        obj.background = bg;
        obj.borderShow = 'none';
        obj.order = index + 1;

        return obj;
      }

      let elementsToSave = [];
      let panels = document.querySelectorAll('#editor-content > [element="PanelComponent"]  > [element="PanelComponent"]');

      panels.forEach((panel, index) => {
        elementsToSave.push(_newElement(panel, index));
      })

      this.panelsToMove = elementsToSave;

      this.$nextTick(() => {
        var el = document.getElementById('sortable-panels-popup');
        if (el) {
          this.sortable = Sortable.create(el);
        }
      });
    },
    saveOrderPanels() {

      let panels = document.querySelectorAll('#sortable-panels-popup > .ordenated-panel-content');
      let ordenatedArray = [];

      panels.forEach((panel) => {
        ordenatedArray.push(panel.getAttribute('data-id'))
      });

      this.$emit('functionChangeOrderPanel', ordenatedArray);
    },

    cancelMove() {
      this.sortable = false;
      this.panelsToMove = [];
    }
  },
  beforeDestroy() {
    this.sortable = false;
    this.panelsToMove = [];
  },
  mounted() {
  }
}
</script>

<style lang="scss" scoped>
.sortable-panels-popup-container {
  position: relative;

  .sortable-panels-popup-content {
    display: grid;
    padding-top: 10px;
    padding-bottom: 10px;
    gap: 6px;
  }

  .sortable-button {
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
  }

  .ordenated-panel-content {
    cursor: move;

    p {
      margin: 0;
      padding: 0;
    }

    .ordenated-panel {
      height: 50px;
      width: 100%;
      margin-bottom: 3px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/editor/apps/Panel/PanelsToMove.vue